/**
 * @fileoverview Language slice — dil tercihi state yönetimi.
 * Side-effect (i18n sync) useLanguage hook içinde yapılır.
 */

import { createSlice } from '@reduxjs/toolkit'

/** @type {{ currentLanguage: string }} */
const initialState = {
  currentLanguage: 'tr',
}

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    /**
     * Aktif dili değiştir.
     * @param {typeof initialState} state
     * @param {{ payload: string }} action
     */
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload
    },
  },
})

export const { setLanguage } = languageSlice.actions

// Memoized selector
/** @param {{ language: typeof initialState }} state */
export const selectCurrentLanguage = (state) => state.language.currentLanguage

export default languageSlice.reducer
